<template>
    <span class="delivery-actions">
        <el-button v-if="bill.id && bill.status === 1 && !readOnly" type="danger" :link="link"
            :size="link ? 'small' : 'default'" :loading="checking" @click="openCancel">取消到货单</el-button>
        <el-button v-if="canReapply" type="primary" :link="link" :size="link ? 'small' : 'default'"
            @click="reapply">按此单重新申请</el-button>
        <el-dialog v-model="visible" title="取消到货单" width="520px" append-to-body :close-on-click-modal="false"
            :close-on-press-escape="!saving" :show-close="!saving">
            <p>将取消到货单 {{ bill.billCode }}，并作废以下采购订单：</p>
            <p>{{ orderCodes.length ? orderCodes.join('、') : '无关联采购订单（直接到货）' }}</p>
            <p>原采购申请保留历史记录。取消后可按此单重新申请。</p>
            <el-input v-model="reason" type="textarea" :rows="3" maxlength="500" show-word-limit
                placeholder="请填写取消原因（必填）" :disabled="saving" />
            <template #footer>
                <el-button :disabled="saving" @click="visible = false">返回</el-button>
                <el-button type="danger" :loading="saving" :disabled="!reason.trim()" @click="confirmCancel">确认取消到货单</el-button>
            </template>
        </el-dialog>
    </span>
</template>

<script>
export default {
    name: 'PurchaseDeliveryActions',
    props: {
        bill: { type: Object, required: true },
        readOnly: Boolean,
        link: Boolean
    },
    emits: ['changed'],
    data() {
        return { visible: false, checking: false, saving: false, reason: '', orderCodes: [], canReapply: false }
    },
    watch: {
        'bill.status': { immediate: true, handler() { this.loadReapplyState() } },
        'bill.id'() { this.loadReapplyState() }
    },
    methods: {
        async info() {
            const response = await this.$kaung.fetch({ url: '/PurchaseDeliveryBill/CancelInfo', method: 'get', params: { id: this.bill.id }, loading: false })
            if (response.code !== 200) throw new Error(response.content || '读取到货单状态失败')
            return response.data
        },
        async loadReapplyState() {
            this.canReapply = false
            if (!this.bill.id || this.bill.status !== -1) return
            const id = this.bill.id
            try {
                const info = await this.info()
                if (this.bill.id === id && this.bill.status === -1) this.canReapply = info.canReapply === true
            } catch (error) { this.$message.error(error.content || error.message || '读取到货单状态失败') }
        },
        async openCancel() {
            if (this.checking || this.saving) return
            this.checking = true
            try {
                const info = await this.info()
                if (!info.canCancel) { this.$message.warning(info.reason || '当前单据不能取消'); return }
                this.orderCodes = info.orderCodes || []
                this.reason = ''
                this.visible = true
            } catch (error) { this.$message.error(error.content || error.message || '读取到货单状态失败') }
            finally { this.checking = false }
        },
        async confirmCancel() {
            if (this.saving || !this.reason.trim()) return
            this.saving = true
            try {
                const response = await this.$kaung.fetch({ url: '/PurchaseDeliveryBill/Cancel', method: 'post', data: { id: this.bill.id, reason: this.reason.trim() } })
                if (response.code !== 200) { this.$message.error(response.content || '取消失败'); return }
                this.visible = false
                this.$message.success(response.content)
                this.$emit('changed')
            } catch (error) { this.$message.error(error.content || error.message || '取消失败，请刷新确认单据状态') }
            finally { this.saving = false }
        },
        reapply() {
            this.$router.push({ name: 'PurchaseRequisitionDetail', query: { sourceDeliveryId: this.bill.id } })
        }
    }
}
</script>

<style scoped>
.delivery-actions { display: inline-flex; gap: 8px; margin-left: 8px; }
</style>
